import type { SupportedLanguage } from '../i18n.js';

export type LegalPath = '/privacy' | '/terms' | '/cookies';

export function legalPathForLanguage(language: string, path: LegalPath): string {
  const normalized = language?.slice(0, 2).toLowerCase();
  const lang: SupportedLanguage = normalized === 'pl' ? 'pl' : 'en';
  return `/${lang}${path}`;
}
